module.exports = __webpack_public_path__ + "media/whd.ba0a25f7.mp4";